module.exports = __webpack_public_path__ + "img/jiuzhou-driver-ios.5b09faba.png";